import { useTranslation } from 'react-i18next';
import { CheckIcon, Clock, Timer, Users } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'components/dropdown/dropdown';
import { Ordering } from 'screens/home/utils';
import {
  ActionButton,
  DropdownItemCheckWrapper,
  DropdownItemIconWrapper,
  DropdownItemText,
  SortIconStyled,
  TimeRangeDropdownItem,
} from './SortFilter.styles';

interface SortFilterProps {
  ordering: Ordering;
  onOrderingChange: (ordering: Ordering) => void;
}

export const SortFilter = ({ ordering, onOrderingChange }: SortFilterProps) => {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <ActionButton>
          <SortIconStyled />
          {t(`home.orderingLabels.${ordering}`)}
        </ActionButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t('home.sortLabel')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <TimeRangeDropdownItem
          $isSelected={ordering === Ordering.ZeitpunktDesc}
          onClick={() => onOrderingChange(Ordering.ZeitpunktDesc)}
        >
          <DropdownItemIconWrapper>
            <Clock className="w-4 h-4 opacity-55" />
          </DropdownItemIconWrapper>
          <DropdownItemText>{t('home.orderingLabels.-zeitpunkt')}</DropdownItemText>
          <DropdownItemCheckWrapper>
            {ordering === Ordering.ZeitpunktDesc && <CheckIcon className="w-4 h-4" />}
          </DropdownItemCheckWrapper>
        </TimeRangeDropdownItem>
        <TimeRangeDropdownItem
          $isSelected={ordering === Ordering.ZeitpunktAsc}
          onClick={() => onOrderingChange(Ordering.ZeitpunktAsc)}
        >
          <DropdownItemIconWrapper>
            <Clock className="w-4 h-4 opacity-55" />
          </DropdownItemIconWrapper>
          <DropdownItemText>{t('home.orderingLabels.zeitpunkt')}</DropdownItemText>
          <DropdownItemCheckWrapper>
            {ordering === Ordering.ZeitpunktAsc && <CheckIcon className="w-4 h-4" />}
          </DropdownItemCheckWrapper>
        </TimeRangeDropdownItem>
        <DropdownMenuSeparator />
        <TimeRangeDropdownItem
          $isSelected={ordering === Ordering.NameAsc}
          onClick={() => onOrderingChange(Ordering.NameAsc)}
        >
          <DropdownItemIconWrapper>
            <Users className="w-4 h-4 opacity-55" />
          </DropdownItemIconWrapper>
          <DropdownItemText>{t('home.orderingLabels.name')}</DropdownItemText>
          <DropdownItemCheckWrapper>
            {ordering === Ordering.NameAsc && <CheckIcon className="w-4 h-4" />}
          </DropdownItemCheckWrapper>
        </TimeRangeDropdownItem>
        <TimeRangeDropdownItem
          $isSelected={ordering === Ordering.NameDesc}
          onClick={() => onOrderingChange(Ordering.NameDesc)}
        >
          <DropdownItemIconWrapper>
            <Users className="w-4 h-4 opacity-55" />
          </DropdownItemIconWrapper>
          <DropdownItemText>{t('home.orderingLabels.-name')}</DropdownItemText>
          <DropdownItemCheckWrapper>
            {ordering === Ordering.NameDesc && <CheckIcon className="w-4 h-4" />}
          </DropdownItemCheckWrapper>
        </TimeRangeDropdownItem>
        <DropdownMenuSeparator />
        <TimeRangeDropdownItem
          $isSelected={ordering === Ordering.DauerAsc}
          onClick={() => onOrderingChange(Ordering.DauerAsc)}
        >
          <DropdownItemIconWrapper>
            <Timer className="w-4 h-4 opacity-55" />
          </DropdownItemIconWrapper>
          <DropdownItemText>{t('home.orderingLabels.dauer')}</DropdownItemText>
          <DropdownItemCheckWrapper>
            {ordering === Ordering.DauerAsc && <CheckIcon className="w-4 h-4" />}
          </DropdownItemCheckWrapper>
        </TimeRangeDropdownItem>
        <TimeRangeDropdownItem
          $isSelected={ordering === Ordering.DauerDesc}
          onClick={() => onOrderingChange(Ordering.DauerDesc)}
        >
          <DropdownItemIconWrapper>
            <Timer className="w-4 h-4 opacity-55" />
          </DropdownItemIconWrapper>
          <DropdownItemText>{t('home.orderingLabels.-dauer')}</DropdownItemText>
          <DropdownItemCheckWrapper>
            {ordering === Ordering.DauerDesc && <CheckIcon className="w-4 h-4" />}
          </DropdownItemCheckWrapper>
        </TimeRangeDropdownItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
